import { useBoolean } from 'ahooks';
import { Badge, Tooltip } from 'antd';
import React, { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Project } from 'api/project';
import { PlaceholderAvatarGroup } from 'components/molecules/placeholder-avatar';
import { RbacButton } from 'components/organisms/rbac/components/rbac-buttons';
import { ProjectResource } from 'hooks/rbac/useWithAccess';
import { ClickEventTags, setMarkerForDataDog } from 'hooks/use-data-dog-logger';
import { PlaceholderResolutionModal } from './modal';
import { useUsersForProject } from './project-users';

interface Props {
  project: Project;
}
export const PlaceholderResolution: FC<Props> = ({ project }) => {
  const [
    placeholderModalVisible,
    {
      setTrue: showPlaceholderResolutionModal,
      setFalse: hidePlaceholderResolutionModal,
    },
  ] = useBoolean(false);
  const { placeholders } = useUsersForProject({ project });
  const hasSomeUnresolvedPlaceholders = useMemo(
    () => placeholders.some((placeholder) => placeholder.resolved !== true),
    [placeholders],
  );

  return (
    <>
      <Tooltip
        title={
          <FormattedMessage id="projects.preview.menu.manage_placeholder" />
        }
      >
        <RbacButton
          icon={
            <Badge dot={hasSomeUnresolvedPlaceholders}>
              <PlaceholderAvatarGroup size={16} />
            </Badge>
          }
          type="text"
          onClick={() => {
            setMarkerForDataDog(
              ClickEventTags.ProjectPlanPlaceholderResolutionPopup,
            );
            showPlaceholderResolutionModal();
          }}
          rule="TASK_ASSIGNEE:READ"
          resourceData={ProjectResource(project)}
        />
      </Tooltip>
      {placeholderModalVisible ? (
        <PlaceholderResolutionModal
          visible={placeholderModalVisible}
          onClose={hidePlaceholderResolutionModal}
          placeholders={placeholders}
          project={project}
        />
      ) : null}
    </>
  );
};
